import React, { type ReactElement, type ReactNode } from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { Skeleton } from '@atlassian/jira-common-components-skeleton/src/styled.tsx';

const ProjectAccessModalViewWrapperSkeleton = (): ReactElement => (
	<>
		<Skeleton width="350px" height="20px" />
		<BarWrapper>
			<SkeletonWrapper>
				<Skeleton width="140px" height="40px" />
			</SkeletonWrapper>
			<SkeletonWrapper>
				<Skeleton width="500px" height="40px" />
			</SkeletonWrapper>
		</BarWrapper>
	</>
);

export default ProjectAccessModalViewWrapperSkeleton;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const BarWrapper = styled.div<{
	children?: ReactNode;
}>({
	display: 'flex',
	margin: `${token('space.100', '8px')} 0 ${token('space.200', '16px')} 0`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SkeletonWrapper = styled.div<{
	children?: ReactNode;
}>({
	marginRight: token('space.200', '16px'),
});
